export default "__VITE_ASSET__a9d8fae7__"